<div class="marketing-tab">
  <div class="toolbar">
    <div>
      <h3 class="section-title">Sequences</h3>
      <div class="subtitle">Enroll recipients from inbound feeds and send campaigns relative to startDate.</div>
    </div>
    <div class="actions">
      <mat-form-field appearance="fill">
        <mat-label>Status</mat-label>
        <mat-select
          [(ngModel)]="sequenceArchiveStatusFilter"
          (selectionChange)="onArchiveStatusFilterChange()"
          >
          @for (option of archiveStatusOptions; track option) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button
        mat-raised-button
        color="primary"
        [disabled]="campaigns.length === 0"
        (click)="add()"
        >
        <mat-icon>add</mat-icon>
        Add New Sequence
      </button>
    </div>
  </div>

  <div class="summary-grid">
    <div class="summary-item">
      <span class="label">Sequences</span>
      <strong>{{ sequenceCount }}</strong>
    </div>
    <div class="summary-item">
      <span class="label">Active</span>
      <strong>{{ getStatusCount('active') }}</strong>
    </div>
    <div class="summary-item">
      <span class="label">Campaigns</span>
      <strong>{{ campaigns.length }}</strong>
    </div>
  </div>

  <div class="table-wrap">
    <table class="table" mat-table matSort [dataSource]="tableDataSource">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td class="cell" mat-cell *matCellDef="let item">
          <div class="cell-primary">{{ item.name }}</div>
          <div class="cell-secondary">{{ item.description || 'No description' }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td class="cell" mat-cell *matCellDef="let item">
          <span class="status-pill" [ngClass]="getStatusClass(item.status)">
            {{ item.status }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="inboundFeed">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Inbound Feed</th>
        <td class="cell cell-truncate" mat-cell *matCellDef="let item">
          {{ item.inboundFeedName || '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="timezone">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Timezone</th>
        <td class="cell cell-truncate" mat-cell *matCellDef="let item">
          {{ item.timezone || '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="steps">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Steps</th>
        <td class="cell cell-truncate sequence-steps" mat-cell *matCellDef="let item">
          {{ item.stepSummary || '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created At</th>
        <td class="cell" mat-cell *matCellDef="let item">
          {{ item.createdAt ? (item.createdAt | date:'medium') : '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actionmenu" stickyEnd>
        <th mat-header-cell matTooltip="Actions" *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item">
          <button
            mat-icon-button
            class="action-button"
            [matMenuTriggerFor]="menu"
            [matMenuTriggerData]="{ item: item }"
            aria-label="Sequence actions"
            (click)="$event.stopPropagation()"
            >
            <mat-icon matTooltip="Actions" class="more">more_vert</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
      <tr class="listitem" mat-row *matRowDef="let rows; columns: columnNames"></tr>
    </table>
    @if (tableDataSource.data.length === 0) {
      <div class="empty">
        No marketing sequences have been created yet.
      </div>
    }
    <mat-menu #menu="matMenu">
      <ng-template matMenuContent let-item="item">
        <button mat-menu-item (click)="edit(item)">
          <mat-icon>edit</mat-icon>
          Edit
        </button>
        @if (!isArchived(item)) {
          <button mat-menu-item (click)="archive(item)">
            <mat-icon>archive</mat-icon>
            Archive
          </button>
        }
      </ng-template>
    </mat-menu>
  </div>
</div>
